/* عالم سمسم – تحسينات تجربة العميل
   1) صفحة المنتج: سطر الشحن المجاني تحت السعر + ميعاد التوصيل بالتاريخ + الدفع عند الاستلام/الاستبدال جنب زرار الشراء
   2) صفحة المنتج لو خلص: بدائل قريبة من ريحته
   3) «شفتها مؤخرًا» في صفحة المنتج والرئيسية
   4) أزرار فلترة سريعة فوق منتجات الأقسام
   5) تذكير لطيف لو العميل رجع وعنده منتجات في السلة */
(function () {
  if (window.SMSMUX) return; window.SMSMUX = 1;
  var FREE = 600000; /* 6,000 ج.م بالقرش */
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PATH = location.pathname.replace(/^\/en(?=\/|$)/, '');
  var RV = 'smsm-rv';
  var cart = null;

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(c) { var v = Math.ceil(c / 100).toLocaleString('en-US'); return EN ? 'EGP ' + v : v + ' ج.م'; }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function img(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300); }
  function after(ref, el) { if (ref && ref.parentNode) ref.parentNode.insertBefore(el, ref.nextSibling); }

  function css() {
    if (document.getElementById('smsm-ux-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-ux-css';
    s.textContent = '' +
      /* شحن مجاني تحت السعر */
      '.smsm-fsl{display:flex;align-items:center;gap:8px;margin:6px 0 12px;padding:8px 12px;border-radius:12px;background:linear-gradient(135deg,#FBF6E6,#F4ECFF);border:1px solid #E9D9A6;font-size:13px;font-weight:700;color:#2B1748;line-height:1.5}' +
      '.smsm-fsl b{color:#4B1E78;font-weight:900}' +
      '.smsm-fsl.is-free{background:linear-gradient(135deg,#ECFBF1,#F4ECFF);border-color:#9FDDB4}' +
      /* ميعاد التوصيل */
      '.smsm-eta{display:flex;align-items:flex-start;gap:8px;margin:12px 0 0;padding:10px 12px;border-radius:12px;background:#F8F5FC;border:1px dashed #D9C8EE;font-size:13px;line-height:1.6;color:#2B1748}' +
      '.smsm-eta b{color:#4B1E78;font-weight:900}' +
      '.smsm-eta small{display:block;color:#7A6A90;font-size:11.5px;font-weight:600}' +
      /* الدفع عند الاستلام + الاستبدال */
      '.smsm-buyok{display:flex;flex-wrap:wrap;gap:6px 8px;margin:10px 0 0}' +
      '.smsm-buyok span{display:inline-flex;align-items:center;gap:5px;padding:5px 10px;border-radius:999px;background:#fff;border:1px solid #ECE6F3;font-size:12px;font-weight:700;color:#4B1E78;white-space:nowrap}' +
      /* بدائل لما المنتج يخلص + شفتها مؤخرًا */
      '.smsm-strip{margin:22px 0 6px;font-family:inherit}' +
      '.smsm-strip__h{margin:0 0 4px;font-size:17px;font-weight:900;color:#2B1748}' +
      '.smsm-strip__p{margin:0 0 12px;font-size:13px;color:#7A6A90}' +
      '.smsm-strip__row{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(140px,170px);gap:12px;overflow-x:auto;padding-bottom:6px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch}' +
      '.smsm-strip--alt .smsm-strip__row{grid-auto-columns:minmax(150px,1fr)}' +
      '.smsm-card{display:flex;flex-direction:column;gap:6px;padding:10px;border-radius:14px;background:#fff;border:1px solid #EFE8F7;text-decoration:none!important;color:#2B1748;scroll-snap-align:start;transition:box-shadow .2s,transform .2s}' +
      '.smsm-card:hover{box-shadow:0 12px 24px -16px rgba(75,30,120,.45);transform:translateY(-2px)}' +
      '.smsm-card__img{aspect-ratio:1;border-radius:10px;background:#FAF8FD;display:flex;align-items:center;justify-content:center;overflow:hidden}' +
      '.smsm-card__img img{width:100%;height:100%;object-fit:contain}' +
      '.smsm-card__t{font-size:12.5px;font-weight:700;line-height:1.45;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.9em}' +
      '.smsm-card__p{font-size:13px;font-weight:900;color:#4B1E78}' +
      '.smsm-card__m{font-size:11px;font-weight:800;color:#1F9D55}' +
      '.smsm-rv-wrap{max-width:1410px;margin:30px auto 10px;padding:0 15px}' +
      '.smsm-strip--alt{padding:14px;border-radius:16px;background:#FFF8F0;border:1px solid #F3DFC2}' +
      /* أزرار الفلترة السريعة */
      '.smsm-chips{display:flex;gap:8px;overflow-x:auto;padding:2px 0 12px;margin:0 0 6px;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
      '.smsm-chips::-webkit-scrollbar{display:none}' +
      '.smsm-chips a{flex:0 0 auto;display:inline-flex;align-items:center;gap:5px;padding:8px 14px;border-radius:999px;border:1px solid #E3D6F2;background:#fff;color:#4B1E78!important;font-size:13px;font-weight:800;text-decoration:none!important;white-space:nowrap;transition:background .2s,color .2s}' +
      '.smsm-chips a:hover{background:#F4ECFF}' +
      '.smsm-chips a.is-on{background:#4B1E78;border-color:#4B1E78;color:#fff!important}' +
      /* تذكير السلة */
      '.smsm-crm{position:fixed;z-index:58;inset-inline-end:16px;bottom:20px;max-width:340px;display:flex;align-items:center;gap:10px;padding:12px 12px 12px 14px;border-radius:16px;background:#2B1748;color:#fff;box-shadow:0 18px 40px -16px rgba(43,23,72,.75);font-family:inherit;transform:translateY(140%);opacity:0;transition:transform .45s cubic-bezier(.2,.8,.2,1),opacity .3s}' +
      '.smsm-crm.is-on{transform:none;opacity:1}' +
      '.smsm-crm__i{flex:0 0 38px;width:38px;height:38px;border-radius:50%;background:#D4AF37;color:#2B1748;display:flex;align-items:center;justify-content:center;font-size:18px}' +
      '.smsm-crm__t{flex:1;min-width:0;font-size:13px;line-height:1.45;font-weight:700}' +
      '.smsm-crm__t small{display:block;color:#E9DDF8;font-weight:600;font-size:11.5px}' +
      '.smsm-crm__go{flex:0 0 auto;padding:8px 12px;border-radius:10px;background:#D4AF37;color:#2B1748!important;font-weight:900;font-size:12.5px;text-decoration:none!important;white-space:nowrap}' +
      '.smsm-crm__x{flex:0 0 auto;background:none;border:0;color:#CBB8E6;font-size:18px;line-height:1;cursor:pointer;padding:2px}' +
      'html.smsm-crm-on .smsm-floating-whatsapp{opacity:0!important;pointer-events:none!important;transition:opacity .3s}' +
      '@media (max-width:989px){.smsm-crm{inset-inline:12px;max-width:none;bottom:calc(var(--smsm-crm-b,70px) + 12px)}}';
    document.head.appendChild(s);
  }

  /* ===== السلة ===== */
  function loadCart() { return getJSON(ROOT + 'cart.js').then(function (c) { cart = c; return c; }); }
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _f = window.fetch;
  if (_f) window.fetch = function (i) {
    var u = typeof i === 'string' ? i : (i && i.url) || '', p = _f.apply(this, arguments);
    if (RX.test(u)) p.then(function () { setTimeout(function () { loadCart().then(fsl); }, 300); }).catch(function () {});
    return p;
  };

  /* ===== صفحة المنتج ===== */
  var prod = null;
  function isProduct() { return /^\/products\/[^/]+\/?$/.test(PATH) && document.querySelector('.product-detail__buy-buttons'); }
  function handle() { return decodeURIComponent(PATH.split('/products/')[1].replace(/\/$/, '')); }

  /* سطر الشحن المجاني تحت السعر */
  function fsl() {
    if (!prod) return;
    var price = document.querySelector('.product-detail__price'); if (!price) return;
    var el = document.querySelector('.smsm-fsl');
    if (!el) { css(); el = document.createElement('div'); el.className = 'smsm-fsl'; el.dir = EN ? 'ltr' : 'rtl'; after(price, el); }
    var sub = cart ? cart.items_subtotal_price : 0, inCart = cart && cart.items && cart.items.some(function (it) { return it.product_id === prod.id; });
    var mine = inCart ? 0 : (prod.price || 0), left = FREE - sub - mine, html;
    if (FREE - sub <= 0) html = EN ? '🎉 Your order already ships <b>for FREE</b>' : '🎉 طلبك عليه <b>شحن مجاني</b> بالفعل';
    else if (left <= 0) html = EN ? '🎉 Add this and your order ships <b>for FREE</b>' : '🎉 ضيف المنتج ده وطلبك يبقى عليه <b>شحن مجاني</b>';
    else if (sub > 0) html = EN ? '🚚 Add this and you\'re just <b>' + fmt(left) + '</b> away from free shipping' : '🚚 مع المنتج ده يفضل لك <b>' + fmt(left) + '</b> على الشحن المجاني';
    else html = EN ? '🚚 <b>Free shipping</b> on orders from ' + fmt(FREE) : '🚚 <b>شحن مجاني</b> للطلبات من ' + fmt(FREE);
    el.classList.toggle('is-free', left <= 0);
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  /* ميعاد التوصيل بالتاريخ (أيام العمل من غير الجمعة، والطلبات بعد 2 الضهر بتتحسب من بكرة) */
  function eta() {
    if (!prod || !prod.available || document.querySelector('.smsm-eta')) return;
    var now = new Date(), cairo = new Date(now.toLocaleString('en-US', { timeZone: 'Africa/Cairo' }));
    var d = new Date(cairo); if (d.getHours() >= 14) d.setDate(d.getDate() + 1);
    function addBiz(base, n) { var x = new Date(base), c = 0; while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 5) c++; } return x; }
    var a = addBiz(d, 1), b = addBiz(d, 3);
    var L = EN ? 'en-GB' : 'ar-EG';
    function f(x) { return x.toLocaleDateString(L, { weekday: 'long', day: 'numeric', month: 'long' }); }
    var el = document.createElement('div'); el.className = 'smsm-eta'; el.dir = EN ? 'ltr' : 'rtl';
    el.innerHTML = '<span aria-hidden="true">📦</span><span>' + (EN ? 'Order now and get it between <b>' + esc(f(a)) + '</b> and <b>' + esc(f(b)) + '</b>' : 'اطلب دلوقتي ويوصلك ما بين <b>' + esc(f(a)) + '</b> و<b>' + esc(f(b)) + '</b>') +
      '<small>' + (EN ? 'Inside Egypt · Gulf orders take longer' : 'داخل مصر · طلبات الخليج بتاخد وقت أطول') + '</small></span>';
    css(); after(document.querySelector('.smsm-buyok') || document.querySelector('.product-detail__buy-buttons'), el);
  }

  /* الدفع عند الاستلام + الاستبدال جنب زرار الشراء */
  function buyok() {
    if (!prod || document.querySelector('.smsm-buyok')) return;
    var bb = document.querySelector('.product-detail__buy-buttons'); if (!bb) return;
    var el = document.createElement('div'); el.className = 'smsm-buyok'; el.dir = EN ? 'ltr' : 'rtl';
    el.innerHTML = EN ? '<span>💵 Cash on delivery</span><span>🔄 Exchange sealed items within 14 days</span><span>🔒 Secure payment</span>'
      : '<span>💵 الدفع عند الاستلام</span><span>🔄 استبدال المنتج المغلق خلال 14 يوم</span><span>🔒 دفع آمن</span>';
    css(); after(bb, el);
  }

  /* ===== كارت صغير ===== */
  function card(x, extra) {
    return '<a class="smsm-card" href="' + ROOT + 'products/' + encodeURIComponent(x.h) + '">' +
      '<span class="smsm-card__img">' + (x.i ? '<img src="' + esc(img(x.i, 300)) + '" alt="" loading="lazy" width="150" height="150">' : '') + '</span>' +
      '<span class="smsm-card__t" data-h="' + esc(x.h) + '">' + esc(rvT(x)) + '</span>' +
      (x.p ? '<span class="smsm-card__p">' + fmt(x.p) + '</span>' : '') + (extra || '') + '</a>';
  }

  /* ===== لو المنتج خلص: بدائل قريبة من ريحته ===== */
  function famv(z) { z = String(z || '').split('|'); if (!z[5]) return null; var v = z[5].split('.').map(Number); return v.length === 8 ? v : null; }
  function gen(z) { z = String(z || '').split('|'); return z[1] || 'u'; }
  function cos(a, b) { var d = 0, x = 0, y = 0; for (var i = 0; i < 8; i++) { d += a[i] * b[i]; x += a[i] * a[i]; y += b[i] * b[i]; } return x && y ? d / Math.sqrt(x * y) : 0; }
  function soldAlt() {
    if (!prod || prod.available || document.querySelector('.smsm-strip--alt')) return;
    var kind = window.SMSMFBT && SMSMFBT.kind;
    getJSON(ROOT + 'products/' + encodeURIComponent(prod.handle) + '?view=smsmfbt').then(function (d) {
      var m = d && d.m; if (!m) return;
      var mf = famv(m.z), mg = gen(m.z), mk = kind ? kind(m) : 'perfume';
      var cols = ['best-sellers', mg === 'm' ? 'men-perfumes' : mg === 'f' ? 'women-perfumes' : 'unisex-perfumes', 'new-arrivals'];
      return Promise.all(cols.map(function (c) { return getJSON(ROOT + 'collections/' + c + '?view=smsmfbt'); })).then(function (lists) {
        var seen = {}, cands = [];
        lists.forEach(function (l) { ((l && l.ps) || []).forEach(function (x) { if (!x || !x.a || seen[x.id] || x.id === m.id) return; seen[x.id] = 1; cands.push(x); }); });
        cands.forEach(function (x) {
          var g = gen(x.z), s = 0, f = famv(x.z);
          if ((mg === 'm' && g === 'f') || (mg === 'f' && g === 'm')) s -= 5;
          if (kind && kind(x) !== mk) s -= 4;
          if (mf && f) s += cos(mf, f) * 10;
          if (x.b && x.b === m.b) s += 1.5;
          if (m.p && x.p) { var r = x.p / m.p; if (r > 0.5 && r < 1.6) s += 1.5; }
          x._s = s; x._m = mf && f ? Math.round(55 + cos(mf, f) * 44) : 0;
        });
        cands.sort(function (a, b) { return b._s - a._s; });
        var top = cands.slice(0, 3); if (!top.length) return;
        var el = document.createElement('section'); el.className = 'smsm-strip smsm-strip--alt'; el.dir = EN ? 'ltr' : 'rtl';
        el.innerHTML = '<h3 class="smsm-strip__h">' + (EN ? 'This one is sold out — try these close matches' : 'المنتج ده خلص حاليًا — جرّب عطور قريبة من ريحته') + '</h3>' +
          '<p class="smsm-strip__p">' + (EN ? 'Picked by scent family and style.' : 'اخترناها لك من نفس عائلة الريحة والطابع.') + '</p>' +
          '<div class="smsm-strip__row">' + top.map(function (x) { return card(x, x._m >= 70 ? '<span class="smsm-card__m">' + (EN ? 'Scent match ' : 'توافق الريحة ') + x._m + '%</span>' : ''); }).join('') + '</div>';
        css(); after(document.querySelector('.smsm-buyok') || document.querySelector('.product-detail__buy-buttons'), el);
      });
    });
  }

  /* ===== شفتها مؤخرًا ===== */
  function rvGet() { try { return JSON.parse(ls(RV) || '[]') || []; } catch (e) { return []; } }
  function rvSave() {
    if (!prod) return;
    var l = rvGet().filter(function (x) { return x && x.h !== prod.handle; });
    var o = rvGet().filter(function (x) { return x && x.h === prod.handle; })[0] || {}; l.unshift({ h: prod.handle, t: prod.title, ta: EN ? o.ta : prod.title, te: EN ? prod.title : o.te, i: prod.featured_image, p: prod.price });
    ls(RV, JSON.stringify(l.slice(0, 12)));
  }
  function rvT(x) { return (EN ? x.te : x.ta) || x.t; } function rvFix(w, l) { var miss = l.filter(function (x) { return !(EN ? x.te : x.ta); }); if (!miss.length) return; Promise.all(miss.map(function (x) { return getJSON(ROOT + 'products/' + encodeURIComponent(x.h) + '.js'); })).then(function (r) { var all = rvGet(); r.forEach(function (p) { if (!p) return; all.forEach(function (x) { if (x && x.h === p.handle) { if (EN) x.te = p.title; else x.ta = p.title; } }); w.querySelectorAll('.smsm-card__t').forEach(function (el) { if (el.getAttribute('data-h') === p.handle) el.textContent = p.title; }); }); ls(RV, JSON.stringify(all)); }); } function rvShow() {
    if (document.querySelector('.smsm-rv-wrap')) return;
    var cur = prod && prod.handle, l = rvGet().filter(function (x) { return x && x.h && x.h !== cur; }).slice(0, 10);
    if (l.length < 2) return;
    var main = document.getElementById('MainContent') || document.querySelector('main'); if (!main) return;
    var w = document.createElement('div'); w.className = 'smsm-rv-wrap'; w.dir = EN ? 'ltr' : 'rtl';
    w.innerHTML = '<section class="smsm-strip"><h3 class="smsm-strip__h">' + (EN ? 'Recently viewed' : 'شفتها مؤخرًا') + '</h3>' +
      '<p class="smsm-strip__p">' + (EN ? 'Pick up where you left off.' : 'كمّل من حيث ما وقفت.') + '</p>' +
      '<div class="smsm-strip__row">' + l.map(function (x) { return card(x); }).join('') + '</div></section>'; rvFix(w, l);
    css();
    /* «شفتها مؤخرًا» تاخد مكان قسم الثيم «شاهدتها مؤخرًا» (اللي بقى مخفي) */
    var old = document.querySelector('[id*="products_recently_viewed"]');
    if (prod && old) { old.parentNode.insertBefore(w, old); old.style.display = 'none'; return; }
    /* لو مش موجود: بعد «عطور ريحتها قريبة من ده» */
    if (prod) { var sim = document.querySelector('.smsm-sim'); sim = sim && sim.closest('[id^="shopify-section"]'); if (sim) { after(sim, w); return; } }
    if (prod) { var sec = document.querySelector('.product-detail__buy-buttons'); sec = sec && sec.closest('[id^="shopify-section"]'); if (sec) { after(sec, w); return; } }
    main.appendChild(w);
  }

  /* ===== أزرار فلترة سريعة في الأقسام ===== */
  function chips() {
    if (!/^\/collections\/[^/]+\/?$/.test(PATH) || document.querySelector('.smsm-chips')) return;
    var grid = document.querySelector('.toolbar-products') || document.getElementById('product-grid'); if (!grid) return;
    var cur = PATH.split('/collections/')[1].replace(/\/$/, '');
    var q = new URLSearchParams(location.search), under = q.get('filter.v.price.lte') === '2000';
    var items = [
      ['men-perfumes', EN ? '👔 Men' : '👔 رجالي'], ['women-perfumes', EN ? '👗 Women' : '👗 حريمي'], ['unisex-perfumes', EN ? '✨ Unisex' : '✨ للجنسين'],
      ['best-sellers', EN ? '🔥 Best sellers' : '🔥 الأكثر مبيعًا'], ['new-arrivals', EN ? '🆕 New' : '🆕 وصل حديثًا'], ['offer-of-the-day', EN ? '🏷️ Deals' : '🏷️ عروض']
    ];
    var base = (EN ? '/en' : '') + '/collections/';
    var h = '<a href="' + location.pathname + (under ? '' : '?filter.v.price.lte=2000') + '" class="' + (under ? 'is-on' : '') + '">' + (EN ? '💸 Under ' + fmt(200000) : '💸 أقل من ' + fmt(200000)) + '</a>';
    h += items.map(function (it) { return '<a href="' + base + it[0] + '" class="' + (cur === it[0] ? 'is-on' : '') + '">' + it[1] + '</a>'; }).join('');
    var el = document.createElement('nav'); el.className = 'smsm-chips'; el.dir = EN ? 'ltr' : 'rtl'; el.setAttribute('aria-label', EN ? 'Quick filters' : 'فلترة سريعة'); el.innerHTML = h;
    css(); grid.parentNode.insertBefore(el, grid);
  }

  /* ===== تذكير السلة (مرة واحدة في الزيارة) ===== */
  function navH() {
    var h = 0;
    document.querySelectorAll('[id*="mobile_navigation_bar"] *').forEach(function (e) {
      if (h) return; var cs = getComputedStyle(e);
      if (cs.position === 'fixed' && cs.display !== 'none') { var r = e.getBoundingClientRect(); if (r.height > 20 && r.bottom >= innerHeight - 2) h = r.height; }
    });
    var st = document.querySelector('.smsm-sticky'); /* شريط «أضف للسلة» الثابت في صفحة المنتج */
    if (st && getComputedStyle(st).display !== 'none') { var r2 = st.getBoundingClientRect(); if (r2.height > 20) h += r2.height; }
    return h;
  }
  function remind() {
    if (/^\/(cart|checkouts?)/.test(PATH) || ss('smsm-crm')) return;
    ss('smsm-crm', '1');
    if (!cart || !cart.item_count) return;
    setTimeout(function () {
      var n = cart.item_count;
      var el = document.createElement('div'); el.className = 'smsm-crm'; el.dir = EN ? 'ltr' : 'rtl'; el.setAttribute('role', 'status');
      var left = FREE - cart.items_subtotal_price;
      el.innerHTML = '<span class="smsm-crm__i" aria-hidden="true">🛒</span><span class="smsm-crm__t">' +
        (EN ? 'You have ' + n + ' item' + (n > 1 ? 's' : '') + ' waiting in your cart' : 'عندك ' + (n === 1 ? 'منتج' : n === 2 ? 'منتجين' : n + ' منتجات') + ' مستنيين في السلة') +
        '<small>' + (left > 0 ? (EN ? fmt(left) + ' away from free shipping' : 'باقي ' + fmt(left) + ' على الشحن المجاني') : (EN ? '🎉 Your order ships free' : '🎉 طلبك عليه شحن مجاني')) + '</small></span>' +
        '<a class="smsm-crm__go" href="' + ROOT + 'cart">' + (EN ? 'Complete order' : 'كمّل طلبك') + '</a>' +
        '<button type="button" class="smsm-crm__x" aria-label="' + (EN ? 'Close' : 'إغلاق') + '">×</button>';
      css(); el.style.setProperty('--smsm-crm-b', navH() + 'px'); document.body.appendChild(el);
      var close = function () { el.classList.remove('is-on'); document.documentElement.classList.remove('smsm-crm-on'); setTimeout(function () { el.remove(); }, 500); };
      el.querySelector('.smsm-crm__x').addEventListener('click', close);
      requestAnimationFrame(function () { el.classList.add('is-on'); if (innerWidth < 990) document.documentElement.classList.add('smsm-crm-on'); });
      setTimeout(close, 12000);
    }, 2500);
  }

  /* ===== تشغيل ===== */
  function start() {
    chips();
    var cp = loadCart();
    if (isProduct()) {
      getJSON(ROOT + 'products/' + encodeURIComponent(handle()) + '.js').then(function (p) {
        if (!p) return; prod = p;
        buyok(); eta(); soldAlt(); rvSave(); rvShow();
        cp.then(fsl);
      });
    } else if (PATH === '/' || PATH === '') { rvShow(); }
    cp.then(remind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
